import React, { useState } from "react";
import "./styles.css";
import { createTank, TankDataProps } from "../../../controller/tankController";

interface AddTankProps {
  showAddTank: boolean;
  setShowAddTank: (value: boolean) => void;
}

function AddTank({ setShowAddTank }: AddTankProps) {
  const [tankVolume, setTankVolume] = useState<string>("");
  const [tankUniqueId, setTankUniqueId] = useState<string>("");
  const [manufactureDate, setManufactureDate] = useState<string>("");
  const [error, setError] = useState<string | null>(null);
  const [addedTank, setAddedTank] = useState({})

  const sizeOptions = [
    { value: "large", label: "Large" },
    { value: "medium", label: "Medium" },
    { value: "small", label: "Small" },
  ];

  const handleDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setManufactureDate(e.target.value);
  };

  const handleSave = async () => {
    if (!tankUniqueId || !tankVolume || !manufactureDate) {
      setError("All fields are required.");
      return;
    }

    const tankData: TankDataProps = {
      tankUniqueId: `TANK${tankUniqueId}`,
      tankVolume: tankVolume,
      manufactureDate,
    };

    try {
      const response = await createTank(tankData);
      const { data } = response;
      setAddedTank(data)
      console.log('added tank: ', addedTank);
      
      alert("Tank added successfully");
      setShowAddTank(false);
    } catch (err) {
      setError("Failed to add tank data. Please try again.");
      alert("Failed to save tank data. Please try again.");
      console.error("Error:", err);
    }
  };

  return (
    <div className="bin-details-wrapper">
      <div className="bin-details">
        <h2 className="bin-details-heading">New Tank Registration</h2>
        <div className="bin-reg-form">
          <div>
            <label>Tank Unique Id</label>
            <input
              name="uniqueId"
              id="select-field"
              className="reg-input"
              value={tankUniqueId}
              onChange={(e) => setTankUniqueId(e.target.value)}
            />
          </div>
          <div>
            <label>Tank Volume</label>
            <select
              name="size"
              id="select-field"
              className="reg-input"
              value={tankVolume}
              onChange={(e) => setTankVolume(e.target.value)}
            >
              <option value="" disabled>
                Select tank volume
              </option>
              {sizeOptions.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>
          <div>
            <label>Manufacture Date</label>
            <input
              type="date"
              name="manufactureDate"
              id="select-field"
              className="reg-input"
              value={manufactureDate}
              onChange={handleDateChange}
              max={new Date().toISOString().split("T")[0]}
            />
          </div>
        </div>
        {error && (
          <p className="error-message" style={{ color: "red" }}>
            {error}
          </p>
        )}
        <div className="save-cancel-btn">
          <button className="save-btn" onClick={handleSave}>
            Save
          </button>
          <button className="cancel-btn" onClick={() => setShowAddTank(false)}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}

export default AddTank;
